import {PublisherActionBar} from '@/pages/publisher/PublisherActionBar.tsx'
import {ListResponsePublisherListItemBean, PublisherBean} from 'common/api/api'
import {publisherApi} from 'common/api/entitiesApi.tsx'
import {ListCard} from 'common/components/ListCard.tsx'
import {SearchInput} from 'common/components/SearchInput.tsx'
import {ListFilters, useAppContext} from 'common/context/AppContext.tsx'
import {CommonRoutes} from 'common/context/commonRoutes'
import {initListFilters, useListFilters} from 'common/util/useListFilters.ts'
import {apiCall} from 'common/util/Util.tsx'
import {useState} from 'react'
import {Link} from 'react-router-dom'
import dayjs from 'dayjs'
import {COLUMN_ID_WIDTH, COLUMN_NAME_WIDTH} from 'common/util/constants.ts'

const PublisherList = () => {
    const appContext = useAppContext()
    const [loading, setLoading] = useState<boolean>(false)
    const [listData, setListData] = useState<ListResponsePublisherListItemBean>()
    const [filters, setFilters] = useState<ListFilters>(initListFilters({sort: {name: 'id', direction: 'desc'}}))
    const {setFilter} = useListFilters(setFilters)

    const loadData = () => {
        apiCall(
            setLoading,
            appContext,
            () => publisherApi.publisherPage(
                filters.sort?.name,
                filters.sort?.direction,
                filters.name,
                { query: { page: filters.page, size: filters.pageSize } }
            ),
            (data) => setListData(data)
        )
    }

    return (
        <ListCard
            loading={loading}
            title="Publishers"
            createName="Publisher"
            listRouteKey={CommonRoutes.PUBLISHER}
            filters={filters}
            setFilters={setFilters}
            createRoute={CommonRoutes.PUBLISHER_CREATE}
            listData={listData}
            loadData={loadData}
            columns={[
                {
                    title: 'ID',
                    dataIndex: 'id',
                    width: COLUMN_ID_WIDTH,
                    fixed: 'left',
                },
                {
                    title: 'Name',
                    dataIndex: 'name',
                    className: 'list-table-name',
                    sorter: true,
                    ellipsis: true,
                    render: (text, record) => (<Link style={{ color: '#5888CF', minWidth: 100 }}
                                                     to={`${CommonRoutes.PUBLISHER}/${record.id}/edit`}>{text}</Link>),
                    width: COLUMN_NAME_WIDTH,
                    fixed: 'left',
                },
                {
                    title: 'Revenue Share',
                    dataIndex: 'revShare',
                    width: 160,
                    sorter: true
                },
                {
                    title: 'Time Zone ID',
                    dataIndex: 'timeZoneId',
                    width: 160,
                    sorter: true
                },
                {
                    title: "Last Modified",
                    dataIndex: "modified",
                    sorter: true,
                    width: 100,
                    render: (date) => date && dayjs(date).format('DD MMM YYYY')
                },
                {
                    title: 'Actions',
                    render: (_, record: PublisherBean) => (
                        <PublisherActionBar record={record} />
                    ),
                    width: 240
                }
            ]}
        >
            <SearchInput value={filters.name} onChange={(value) => setFilter('name', value)} />
        </ListCard>
    )
}

export default PublisherList
